import styled from 'styled-components/macro'

export const Text = styled.p`
  color: #171717;
`
